/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Update_SuccessInputs */

const en_shipping_update_success = /** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order marked as fulfilled!`)
};

const es_shipping_update_success = /** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Pedido marcado como completado!`)
};

const fr_shipping_update_success = /** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande marquée comme traitée !`)
};

const de_shipping_update_success = /** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung als erfüllt markiert!`)
};

const id_shipping_update_success = /** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan ditandai sebagai selesai!`)
};

/** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */
const ja_shipping_update_success = en_shipping_update_success;

/** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */
const zh_shipping_update_success = en_shipping_update_success;

/** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */
const ar_shipping_update_success = en_shipping_update_success;

/** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */
const it_shipping_update_success = en_shipping_update_success;

/** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */
const ru_shipping_update_success = en_shipping_update_success;

/** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */
const pt_shipping_update_success = en_shipping_update_success;

/** @type {(inputs: Shipping_Update_SuccessInputs) => LocalizedString} */
const ko_shipping_update_success = en_shipping_update_success;

/**
* | output |
* | --- |
* | "Order marked as fulfilled!" |
*
* @param {Shipping_Update_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_update_success = /** @type {((inputs?: Shipping_Update_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Update_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_update_success(inputs)
	if (locale === "es") return es_shipping_update_success(inputs)
	if (locale === "fr") return fr_shipping_update_success(inputs)
	if (locale === "de") return de_shipping_update_success(inputs)
	if (locale === "ja") return ja_shipping_update_success(inputs)
	if (locale === "zh") return zh_shipping_update_success(inputs)
	if (locale === "ar") return ar_shipping_update_success(inputs)
	if (locale === "id") return id_shipping_update_success(inputs)
	if (locale === "it") return it_shipping_update_success(inputs)
	if (locale === "ru") return ru_shipping_update_success(inputs)
	if (locale === "pt") return pt_shipping_update_success(inputs)
	return ko_shipping_update_success(inputs)
});